// Remembers whether the Advanced settings group is expanded, across reloads and
// sessions. Best-effort; storage may be unavailable (private mode, quota).

export const ADVANCED_SETTINGS_EXPANDED_KEY = 'ai_studio_advanced_settings_expanded'

export const saveAdvancedSettingsExpanded = (isExpanded) => {
  try {
    window.localStorage.setItem(ADVANCED_SETTINGS_EXPANDED_KEY, String(!!isExpanded))
  } catch (_) {
    // No-op.
  }
}

export const readStoredAdvancedSettingsExpanded = () => {
  try {
    return window.localStorage.getItem(ADVANCED_SETTINGS_EXPANDED_KEY) === 'true'
  } catch (_) {
    return false
  }
}
